<p-toast [style]="{marginTop: '80px'}"></p-toast>

<!-- PHASE 1: Setup -->
@if (phase === 'setup') {
<div class="setup-container">
  <div class="setup-header">
    <h3>AI Content Generator</h3>
    <p class="text-muted">Tell Claude what to write. You can refine the output through conversation.</p>
  </div>

  <form [formGroup]="setupForm">
    <div class="row mb-3">
      <div class="col-md-6">
        <label class="form-label">Content Type *</label>
        <select class="form-select" formControlName="contentTypeId">
          @for (t of contentTypes; track t.contentTypeId) {
            <option [ngValue]="t.contentTypeId">{{t.name}}</option>
          }
        </select>
      </div>
      <div class="col-md-6">
        <label class="form-label">Generated By</label>
        <select class="form-select" formControlName="generatedBy">
          <option value="Claude">Claude</option>
          <option value="GPT-4">GPT-4</option>
          <option value="Gemini">Gemini</option>
          <option value="Manual">Manual</option>
        </select>
      </div>
    </div>

    <div class="row mb-3">
      <div class="col-md-3">
        <label class="form-label">Location ID</label>
        <input class="form-control" formControlName="locationId" type="number" placeholder="e.g. 1 for Maui">
      </div>
      <div class="col-md-3">
        <label class="form-label">Property ID</label>
        <input class="form-control" formControlName="shortTermRentalId" type="number" placeholder="STR id">
      </div>
      <div class="col-md-3">
        <label class="form-label">Development ID</label>
        <input class="form-control" formControlName="developmentId" type="number" placeholder="dev id">
      </div>
      <div class="col-md-3">
        <label class="form-label">ADR Region</label>
        <input class="form-control" formControlName="adrRegion" placeholder="e.g. WEST_MAUI">
      </div>
    </div>

    <div class="mb-3">
      <label class="form-label">What should Claude write about? *</label>
      <textarea class="form-control" formControlName="topic" rows="2"
        placeholder="e.g. Best sunset dining spots in Ka'anapali with restaurant recommendations"></textarea>
      <div *ngIf="setupForm.get('topic').invalid && setupForm.get('topic').touched" class="text-danger small mt-1">
        Topic is required (at least 5 characters).
      </div>
    </div>

    <div class="mb-3">
      <label class="form-label">Additional notes for Claude (optional)</label>
      <textarea class="form-control" formControlName="additionalNotes" rows="2"
        placeholder="e.g. Focus on oceanfront restaurants, mention happy hour deals, include Hula Grill"></textarea>
    </div>

    <div class="mb-3">
      <label class="form-label text-muted" style="font-size: 0.85rem;">Quick topic ideas:</label>
      <div class="topic-chips">
        @for (topic of suggestedTopics; track topic) {
          <span class="topic-chip" (click)="useSuggestion(topic)">{{topic}}</span>
        }
      </div>
    </div>

    <div class="text-end">
      <button pButton class="p-button" (click)="startChat()" [disabled]="setupForm.invalid">
        Start Writing
      </button>
    </div>
  </form>
</div>
}

<!-- PHASE 2: Chat -->
@if (phase === 'chat') {
<div class="chat-wrapper">
  <div class="chat-container" #chatContainer>
    @for (msg of messages; track msg.timestamp) {
      <div class="message" [class.user]="msg.role === 'user'" [class.assistant]="msg.role === 'assistant'">
        <div class="bubble" [class.user-bubble]="msg.role === 'user'" [class.assistant-bubble]="msg.role === 'assistant'">
          @if (msg.role === 'assistant' && msg.isContent) {
            <div class="content-preview" [innerHTML]="msg.text"></div>
          } @else {
            <div class="message-text">{{msg.text}}</div>
          }
          <div class="timestamp">{{msg.timestamp | date:'shortTime'}}</div>
        </div>
      </div>
    }

    @if (loading) {
      <div class="message assistant">
        <div class="bubble assistant-bubble">
          <div class="typing">
            <span></span><span></span><span></span>
          </div>
        </div>
      </div>
    }
  </div>

  <div class="chat-input">
    <div class="input-row">
      <textarea [formControl]="form.controls['question']"
        placeholder="Refine the content... e.g. 'Make it longer', 'Add a section about snorkeling', 'Change the tone to be more casual'"
        rows="2" (keydown)="onKeyDown($event)" class="form-control"></textarea>
      <button pButton class="p-button send-btn" (click)="ask()" [disabled]="loading || form.invalid">
        <i class="pi pi-send"></i>
      </button>
    </div>
    <div class="action-row">
      <button pButton class="p-button-text p-button-sm" (click)="clearChat()">
        <i class="pi pi-refresh"></i> Start Over
      </button>
      <button pButton class="p-button-success p-button-sm" (click)="saveAsDraft()" [disabled]="!lastContentHtml || loading">
        <i class="pi pi-save"></i> Save as Draft
      </button>
    </div>
  </div>
</div>
}
